export const ALPHABET = Array.from(Array(26)).map((_, i) => String.fromCharCode(i + 65))

export const VALIDATION_MESSAGES = {
  badInput: null,
  customError: null,
  patternMismatch: 'De ingevulde waarde is niet correct',
  rangeOverflow: 'De ingevulde waarde is te hoog',
  rangeUnderflow: 'De ingevulde waarde is te laag',
  stepMismatch: null,
  tooLong: 'De ingevulde waarde is te lang',
  tooShort: 'De ingevulde waarde is te kort',
  typeMismatch: 'De ingevulde waarde is niet correct',
  valid: 'De ingevulde waarde is correct',
  valueMissing: 'Dit veld is verplicht',
}

export const ERROR_MESSAGES = {
  invalidOrganizationEmail: 'Het ingevulde e-mailadres komt niet overeen met een organisatie die bij ons bekend is.',
  fileSizeLimitExceeded: 'Het bestand is te groot. De maximale grootte is 25MB.',
  minFilesOfThreeNotReached: 'Er moeten minimaal 3 bestanden geüpload worden.',
  maxFilesOfEightNotReached: 'Er mogen maximaal 8 bestanden geüpload worden.',
}

export const FUNCTIONS = [
  { name: 'Marketing en communicatie', id: 'ae87f80b-1fc6-4124-ba4d-ab4b9fcac135' },
  { name: 'CEO', id: 'c3c2af1b-52eb-11e9-ab41-42010a016002' },
  { name: 'CFO', id: 'c3c2b066-52eb-11e9-ab41-42010a016002' },
  { name: 'Planning en administratie', id: '4d5c6128-15d1-4e2b-85e4-f1d188a4231c' },
  { name: 'HR', id: 'b8167db2-4db7-4849-854a-7bd1ed8926b6' },
  { name: 'Pedagogiek', id: '147759e1-0452-4b24-bd0b-58efeec2ee80' },
  { name: 'Bestuurder', id: '375fd602-71cf-4678-9a04-7c94c406cdbd' },
  { name: 'Financiën', id: 'bfc3bac5-7529-452d-a1b6-7bc5914753a0' },
  { name: 'Regio/vestigingsmanager', id: '8d4d62d2-4c9f-4f7b-9002-e73b9f48443b' },
  { name: 'Overig', id: 'dbc91e8c-acc3-4e8b-bf90-df6ace53ef0a' },
  { name: 'Eigenaar', id: 'f251423e-0541-4469-ab03-77b230dbcbba' },
  { name: 'Directeur', id: 'c3c2b1c7-52eb-11e9-ab41-42010a016002' },
]

export const PROVINCES = [
  { name: 'Drenthe', id: '89bcf7f6-09ca-4315-9cf1-1cc2a2cb82bf' },
  { name: 'Flevoland', id: '09db6a27-3dd0-44f0-aa55-2efc018e019e' },
  { name: 'Friesland', id: '37a9a676-82a8-4036-bfb5-d0de49b6ac12' },
  { name: 'Gelderland', id: 'bc05a2c6-774a-4fd1-b6cb-90fad072e21a' },
  { name: 'Groningen', id: 'cd2da46a-1b48-42c8-a31f-34a8179afb23' },
  { name: 'Limburg', id: '9c65ae9b-d172-4965-83a3-d55fb7898576' },
  { name: 'Noord-Brabant', id: 'da6750d1-5737-4e34-b8b2-279efec6c1dc' },
  { name: 'Noord-Holland', id: '7cdd1f9b-670d-444a-87ae-fb031e000dc0' },
  { name: 'Overijssel', id: '801871cc-a485-4738-ae0a-642019a85274' },
  { name: 'Zuid-Holland', id: '8cbee18c-eb98-478a-a093-8c11ed3d2a47' },
  { name: 'Utrecht', id: '008117f4-d9ef-4fe5-acf1-2b6321c4f8d7' },
  { name: 'Zeeland', id: '3d5e55dc-20e5-42af-a13a-21f7d5e59b93' },
]

export const PATTERNS = {
  letters: String.raw`[A-Za-z_- ]+`,
  letters_numbers: String.raw`[a-zA-Z0-9]+`,
  letters_spaces_dashes: String.raw`^[a-zA-Z\s\-]+$`,
  letters_spaces_dashes_dots: String.raw`^[a-zA-Z\s\-\.]+$`,
  letters_numbers_spaces_dashes: String.raw`^[a-zA-Z0-9\s\-]+$`,
  numbers: String.raw`^[0-9]*$`,
  phone: String.raw`^(?:0|\(?\+31\)?\s?|0031\s?)[1-9](?:[\-\s]?\d\d){4}$`, // https://www.html5pattern.com/Phones
  email: String.raw`[^@]+@[^@]+\.[a-zA-Z]{2,6}`,
  postal_code: String.raw`[1-9][0-9]{3}\s?[a-zA-Z]{2}`, // https://www.html5pattern.com/Postal_Codes
  url: String.raw`(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)`,
}

export const ERRORS = {
  posts: 'Er is iets misgegaan tijdens het ophalen van de nieuwsberichten',
}

export const CONTENT_TYPES = [
  { key: 'post', value: 'Nieuws' },
  { key: 'page', value: 'Pagina' },
  { key: 'subject', value: 'Onderwerp' },
  { key: 'download', value: 'Download' },
  { key: 'podcast', value: 'Podcast' },
  { key: 'event', value: 'Agenda' },
  { key: 'press_release', value: 'Persbericht' },
]
